<input
  type="file"
  #fileInput
  (change)="uploadFile($event)"
  hidden="true"
  accept="image/png,image/jpeg,application/pdf"
  (click)="resetFile()"
/>
<ng-container *ngIf="uploadedFileDetails?.fileObject">
  <ion-card class="uploadFile uploadPic ion-text-center">
    <img
      *ngIf="uploadedFileDetails?.fileExt !== 'pdf'"
      [src]="uploadedFileDetails?.selectedFileBLOB"
    />
    <img
      *ngIf="uploadedFileDetails?.fileExt === 'pdf'"
      src="assets/images/pdf-svg.svg"
    />
    <div *ngIf="!isDisabled" class="imgClose" (click)="removeImage()">
      <ion-icon name="trash-outline"></ion-icon>
    </div>
  </ion-card>
</ng-container>
<ng-container *ngIf="!uploadedFileDetails?.fileObject && addedFile">
  <ion-card class="uploadFile uploadPic ion-text-center">
    <img *ngIf="fileExt !== 'pdf'" [src]="addedFile" />
    <a (click)="downloadFile()" title="Download File"
      ><img *ngIf="fileExt === 'pdf'" src="assets/images/pdf-svg.svg"
    /></a>
    <div *ngIf="!isDisabled" class="imgClose" (click)="removeImage()">
      <ion-icon name="trash-outline"></ion-icon>
    </div>
  </ion-card>
</ng-container>
<ng-container *ngIf="!uploadedFileDetails?.fileObject && !addedFile">
  <ion-card
    [ngClass]="{
      'error-border': !parentForm?.controls[fileControlName]?.valid
    }"
    (click)="selectImageSource()"
    class="uploadFile ion-text-center"
  >
    <img src="assets/images/icon-cloud.svg" />
    <h3>
      <!-- <ion-icon class="custom-camera"></ion-icon> -->
      {{ "Upload Photo ID" | translate }}
    </h3>
    <ion-text>{{ "Click & Upload" | translate }}</ion-text>
  </ion-card>
</ng-container>
<div *ngIf="fileError" class="error-validation">
  <p>{{ fileError }}</p>
</div>
